import { render, staticRenderFns } from "./ComplianceAccountStatus.vue?vue&type=template&id=bc369c78&scoped=true&"
import script from "./ComplianceAccountStatus.vue?vue&type=script&lang=js&"
export * from "./ComplianceAccountStatus.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceAccountStatus.vue?vue&type=style&index=0&id=bc369c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc369c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc369c78')) {
      api.createRecord('bc369c78', component.options)
    } else {
      api.reload('bc369c78', component.options)
    }
    module.hot.accept("./ComplianceAccountStatus.vue?vue&type=template&id=bc369c78&scoped=true&", function () {
      api.rerender('bc369c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ComplianceAccountStatus.vue"
export default component.exports